import type { NavigateFunction } from 'react-router';
import { useNavigate } from 'react-router-dom';

export const navigationRef: { current: null | NavigateFunction } = { current: null };

export function NavigationSetter() {
    navigationRef.current = useNavigate();
    return null;
}
